export enum ClientDeliveryService {
  HomeDelivery= 1,
  HomeReturn  = 2,
  LockerDelivery = 3,
  LockerReturn = 4,
}
